import React from 'react';
import { Button } from './ui/button';
import { Car, Sparkles, ShieldCheck, PackageCheck } from 'lucide-react';

export default function CTASection({ onBook }) {
  return (
    <section className="relative py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="rounded-3xl p-[1.5px]" style={{background:'linear-gradient(90deg,#a855f7,#ec4899)'}}>
          <div className="rounded-3xl bg-[#0f0f16] p-8 md:p-14 text-center">
            <div className="section-title-eyebrow uppercase">Special Launch Offer</div>
            <h2 className="mt-3 text-3xl md:text-5xl font-extrabold">
              <span className="text-white">તમારી કારની સંભાળ લેવાની </span><span className="gradient-text">શ્રેષ્ઠ રીત</span>
            </h2>
            <p className="mt-4 text-gray-400 max-w-2xl mx-auto">Diamond AMC લી લો અને 2 વર્ષ સુધી મેન્ટેનન્સની ચિંતામાંથી મુક્ત બનો. ફક્ત ₹111 પ્રતિ સર્વિસ.</p>
            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
              <div className="text-left rounded-2xl border border-purple-900/60 bg-[#14141c] px-5 py-3">
                <div className="text-xs text-gray-400">Diamond AMC પ્લાન</div>
                <div className="flex items-baseline gap-2"><span className="gradient-text text-3xl font-extrabold">₹4,999</span><span className="text-sm text-gray-500 line-through">₹24,400</span></div>
              </div>
              <Button onClick={() => onBook('diamond')} className="gradient-btn rounded-full h-12 px-6 font-semibold">🚗 હમણાં જ બુક કરો</Button>
            </div>
            <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-sm text-gray-300">
              <div className="flex items-center justify-center gap-2"><ShieldCheck className="w-4 h-4 text-pink-400" /> જેન્યુઇન પાર્ટ્સ</div>
              <div className="flex items-center justify-center gap-2"><Car className="w-4 h-4 text-pink-400" /> ફ્રી પિકઅપ & ડ્રોપ</div>
              <div className="flex items-center justify-center gap-2"><PackageCheck className="w-4 h-4 text-pink-400" /> સર્વિસ વોરંટી</div>
              <div className="flex items-center justify-center gap-2"><Sparkles className="w-4 h-4 text-pink-400" /> તમામ બ્રાન્ડ</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
